/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultBcDetails } from '../../models/api-response-paged-result-bc-details';
import { PagedRequestExecutionDetailsFilter } from '../../models/paged-request-execution-details-filter';

export interface SearchExecutionDetails$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  executionReference: string;
      body: PagedRequestExecutionDetailsFilter
}

export function searchExecutionDetails(http: HttpClient, rootUrl: string, params: SearchExecutionDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultBcDetails>> {
  const rb = new RequestBuilder(rootUrl, searchExecutionDetails.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('executionReference', params.executionReference, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultBcDetails>;
    })
  );
}

searchExecutionDetails.PATH = '/v1/api/ui/broadcast/executions/{executionReference}/details';
